// extracted by mini-css-extract-plugin
module.exports = {"page":"_9942","record":"_2938","hd":"_11968","title":"_18835","action":"_17830","icon":"_16636","text":"_15620","bd":"_4975","item":"_17340"};